import { Persona } from './persona';
import { Adjunto } from './adjunto';
import { FormularioAuditoria } from './formulario-auditoria';
import { FormularioSustento } from './sustento';

export class Formulario {
  Seleccionado: boolean;
  IdFormulario: number;
  IdConvocatoria: number;
  IdProvincia: number;
  IdDepartamento: number;
  NroFormulario: string;
  IdTipoGrupo: number;
  FechaInscripcion: string;
  FechaRegistro: string;
  IdModalidad: number;
  IndicadorConformacion: number;
  IndicadorIFM: number;
  IndicadorPropiedad: number;
  IndicadorProductoFMV: number;
  IndicadorDeuda: number;
  TotalIngreso: number;
  Estado: number;
  UsuarioCreacion: string;
  FechaCreacion: Date;
  UsuarioModificacion: string;
  FechaModificacion: Date;
  ListaPersonas: Array<Persona> = [];
  NroConvocatoria: string;
  NombreTipoGrupo: string;
  NombreEstado: string;
  ListaAdjuntos: Array<Adjunto> = [];
  ListaAdjuntosSustento: Array<Adjunto> = [];
  ListaAuditoria: Array<FormularioAuditoria> = [];
  NombreGradoInstruccion: string;
  CantidadDiasCaduca: number;
  TipoProceso: number;
  FormSustento: FormularioSustento;
  NombreModalidad: string;
  CumpleTodo: string;
  ListaReportePersona: Array<Persona> = [];
  Observacion: string;
  constructor(TipoProceso: number) {
    this.TipoProceso = TipoProceso;
  }
}
